import React from 'react';
import { WalletIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
export function AllowanceCard({
  memberId
}: {
  memberId: string;
}) {
  const {
    family,
    weekFor,
    db
  } = useAppState();
  const week = weekFor(memberId);
  const r = family.rules;
  const history = db.weekCloses.filter(w => w.familyId === family.id).flatMap(w => w.rows.filter(row => row.memberId === memberId).map(row => ({
    ...row,
    weekId: w.weekId
  })));
  return <section aria-labelledby="allowance" className="rounded-3xl bg-done-soft p-5" data-id="element-294" data-mp="x5hnfqtvfrff">
      <h2 id="allowance" className="flex items-center gap-2 font-display text-lg font-semibold text-done-ink" data-id="element-295" data-mp="x7kca7jafeik">
        <WalletIcon className="h-5 w-5" aria-hidden="true" data-id="element-296" data-mp="nfent7s8vf84" /> {week.reached ? 'KAČING!' : 'Žepnina'}
      </h2>
      <p className="mt-2 font-display text-4xl font-semibold tabular-nums text-done-ink" data-id="element-297" data-mp="1kuirz2zl2iff">
        {week.reached ? `${r.allowanceAmount} ${r.currency}` : `0 ${r.currency}`}
      </p>
      <p className="mt-1 text-sm text-done-ink" data-id="element-298" data-mp="1alvzkge2cvrw">
        {week.reached ? `Žepnina je tvoja. Izplačilo ${r.payoutDay} ob ${r.payoutTime} po pregledu staršev.` : `Pri ${r.basicThresholdPct} % je kačing: ${r.allowanceAmount} ${r.currency} v ${r.payoutDay === 'nedelja' ? 'nedeljo' : r.payoutDay} zvečer.`}
      </p>
      {history.length > 0 && <ul className="mt-3 space-y-1 border-t border-done/20 pt-3 text-sm text-done-ink" data-id="element-299" data-mp="15tkxb6vuoxw6">
          {history.map(h => <li key={h.weekId} className="flex justify-between" data-id="element-300" data-mp="rxr19og6e30h">
              <span data-id="element-301" data-mp="vyjcgn8lyhze">Teden {h.weekId.slice(-3)} · {h.pct} %</span>
              <span className="font-bold" data-id="element-302" data-mp="hxqic3m7xowt">{h.paid ? `izplačano ${h.amount} ${r.currency}` : h.reached || h.override ? 'čaka izplačilo' : 'ni doseženo'}</span>
            </li>)}
        </ul>}
    </section>;
}